import type { Components, Theme } from "@mui/material/styles";
import { RadiusToken } from "../../tokens/radii";

export const MuiLink: NonNullable<Components<Theme>["MuiLink"]> = {
  defaultProps: { underline: "always" },
  styleOverrides: {
    root: ({ theme }) => {
      const rmh = theme.vars!.palette.rmh;
      return {
        ...theme.typography.bodyMdRegular,
        color: rmh.text.interactiveLink,
        textDecorationColor: rmh.border["5-brand"].rest,
        transition: theme.transitions.create(
          ["text-decoration-color", "box-shadow"],
          { duration: theme.transitions.duration.shortest }
        ),
        "&:hover": {
          textDecorationColor: rmh.border["5-brand"].hover,
        },
        "&:focus-visible": {
          outline: "none",
          boxShadow: rmh.focus.primary,
          borderRadius: RadiusToken.MD,
        },
      };
    },
  },
};
